import { GroupRelationshipBase } from './base/group-relationship-base';

export class GroupRelationship extends GroupRelationshipBase { }